import { SummaryAccordionItem } from "@/components/summary/SummaryAccordion"
import { AccordionContent } from "@/components/ui/accordion"

import type { CustomerApplications } from "@boundless/bl-api-client/customer/models"

type SummaryApplicationProps = {
  application: CustomerApplications
  returnTo: string
}

export function SummaryDocuments({ application }: SummaryApplicationProps) {
  return (
    <SummaryAccordionItem
      value="documents"
      title="Documents"
      checkIcon={application.hasAllRequiredDocuments}
    >
      <AccordionContent className="px-4 pt-2 pb-4">
        <div className="mt-2 flex flex-wrap gap-4">
          {application.assignedDocuments.map((doc, index) => (
            <div key={index} className="flex flex-col items-center">
              <img src={`${doc.thumbnailUrl}`} className="h-25 w-20" />
            </div>
          ))}
        </div>
      </AccordionContent>
    </SummaryAccordionItem>
  )
}
